import React, { Component } from 'react';
import Route from 'react-router-dom/Route';
import { Helmet } from "react-helmet";

import ItemIndexPage from './pages/Index';
import ItemShowPage from './pages/Show';

export default (props) =>
    <main>
        <Helmet titleTemplate="%s | Wydarzenia | Gamedev.js" defaultTitle="Wydarzenia | Gamedev.js" />

        <Route key="index" exact path={props.match.url} component={ItemIndexPage}/>
        <Route key="item" path={props.match.url + '/:slug'} component={ItemShowPage}/>
    </main>



// WEBPACK FOOTER //
// ./src/modules/Events/Module.js